export const translateAction = (data) => {
  return {
    type: "CHANGE",
    payload: data,
  };
};
